import Vue from 'vue'
import vueRouter from 'vue-router'
import App from './App.vue'
import './registerServiceWorker'
import 'animate.css';
import { routes } from './router/index'
import { store } from './store/index'
import BootstrapVue from 'bootstrap-vue'
import VueSession from 'vue-session'
import Widget from './components/Widget/Widget'
import MyPlugin from './GlobalPlugin'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCookies from 'vue-cookies'
import Spinner from 'vue-spinkit'
import Toasted from 'vue-toasted'
import VueNativeNotification from 'vue-native-notification'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import darkUnica from 'highcharts/themes/dark-unica'
import StarRating from 'vue-star-rating'
import VueApexCharts from 'vue-apexcharts'
import excel from 'vue-excel-export'
import VueTheMask from 'vue-the-mask'
import WebCam from 'vue-web-cam'
// import Paintable from 'vue-paintable'

Vue.use(WebCam)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(excel)
darkUnica(Highcharts)
Vue.use(HighchartsVue)
Vue.use(Toasted, { duration: 5000, position: 'bottom-left' })
Vue.component('Spinner', Spinner)
Vue.component('star-rating', StarRating)
Vue.use(BootstrapVue)
Vue.use(VueSession)
Vue.component('Widget', Widget)
Vue.use(MyPlugin)
Vue.use(VueSweetalert2)
Vue.use(vueRouter)
Vue.use(VueTheMask)
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
})
// Vue.use(Paintable, {
//   // optional methods
//   setItem(key, image) {
//     localStorage.setItem(key, image)
//   },
//   // you also can use async
//   getItem(key) {
//     return localStorage.getItem(key)
//   },
//   removeItem(key) {
//     localStorage.removeItem(key)
//   },
// })
// default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' }
Vue.use(VueCookies, { expire: '7d' })
const router = new vueRouter({
  routes,
  mode: 'history',
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
